import {
  Bitmap,
  Container,
  delayedCall,
  dispatcher,
  IEvent,
  ingenuity,
  IObject,
  killDelayedCall,
  Meter,
  SpineBase,
} from "@quest/base-core";
import { HoldAndReSpinView } from "../View/HoldAndReSpinView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { gameConstants } from "../../Constants/gameConstants";
import { GameParserModel } from "../../Platform/GameParserModel";
import { BitmapImage, Emitter } from "@quest/pixi-bridge";
import { ITween } from "@quest/adapter-interface";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class HoldAndRespinUpdatePrizeContorller {
  protected view: HoldAndReSpinView;
  private triggeredSymbol: any;
  private trailCounter: number = 0;
  private tweenArray: ITween[] = [];
  private index: number = 0;
  private allInitialSkulls: any[];
  private triggerType: number;
  private collectAllSkullPriceUpdated: boolean = false;
  private ifOnReelSymbol: boolean = false;
  private multiplierValues: number[] = [2, 3, 5];
  private onReeloffSet: any[] = [];
  private bigPrizeReelData: any[];
  private collectAllReelData: any[];
  private multiplerReelData: any[];
  private multiplierReelIndex: number = 0;
  private bigPrizeReelIndex: number = 0;
  private particleData: any = {
    emitterType: 1,
    id: "coinEmitter_1",
    autoStart: false,
    animConfig: [
      {
        framerate: 20,
        loop: true,
        image: "particle",
        generateFrames: false,
        frame: 0,
      },
    ],
  };

  //particle data for trail from multipler skull to left character
  private particleDataRed: any = {
    emitterType: 1,
    id: "coinEmitter_3",
    autoStart: false,
    animConfig: [
      {
        framerate: 20,
        loop: true,
        image: "red_pixel",
        generateFrames: false,
        frame: 0,
      },
    ],
  };

  //config for trail from multipler skull to left character
  private particleConfigRed: any = {
    alpha: {
      start: 1,
      end: 0,
    },
    scale: {
      start: 0.1,
      end: 1.4,
      minimumScaleMultiplier: 3,
    },
    color: {
      start: "#bd563d",
      end: "#eb1221",
    },
    speed: {
      start: 50,
      end: 50,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 0,
      max: 360,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 0.2,
      max: 0.8,
    },
    blendMode: "add",
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 500,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: "point",
  };

  // Particle Config data
  private particleConfig: any = {
    alpha: {
      start: 1,
      end: 0,
    },
    scale: {
      start: 1.2,
      end: 0.5,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: "#f5ed0a",
      end: "#f5ed0a",
    },
    speed: {
      start: 0,
      end: 0,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    lifetime: {
      min: 0.35,
      max: 0.5,
    },
    blendMode: "screen",
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 10000,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: "point",
  };
  constructor(viewJson: HoldAndReSpinView) {
    this.view = viewJson;
    this.subscribeEvents();
    this.initializeElements();
  }

  protected subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_SYMBOL_PRICE_MULTIPLER, this.updatePrizeForMutiplier, this);
    dispatcher.on(eventDispatchers.UPDATE_SYMBOL_PRICE_BIG_PRIZE, this.updatePrizeForBigPrize, this);
    dispatcher.on(eventDispatchers.UPDATE_SYMBOL_PRICE_COLLECT_ALL, this.updatePrizeForCollectAll, this);
    dispatcher.on(eventDispatchers.SHOW_AMOUNT_ON_COLLECT_ALL_REEL, this.showCollectAllPriceOnReel, this);
    dispatcher.on(eventDispatchers.SHOW_AMOUNT_ON_BIG_PRIZE_REEL, this.showBigPrizePriceOnReel, this);
    dispatcher.on(eventDispatchers.SHOW_AMOUNT_ON_MULTIPLER_REEL, this.showMultiplerPriceOnReel, this);
  }

  public unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.UPDATE_SYMBOL_PRICE_MULTIPLER, this.updatePrizeForMutiplier, this);
    dispatcher.off(eventDispatchers.UPDATE_SYMBOL_PRICE_BIG_PRIZE, this.updatePrizeForBigPrize, this);
    dispatcher.off(eventDispatchers.UPDATE_SYMBOL_PRICE_COLLECT_ALL, this.updatePrizeForCollectAll, this);
    dispatcher.off(eventDispatchers.SHOW_AMOUNT_ON_COLLECT_ALL_REEL, this.showCollectAllPriceOnReel, this);
    dispatcher.off(eventDispatchers.SHOW_AMOUNT_ON_BIG_PRIZE_REEL, this.showBigPrizePriceOnReel, this);
    dispatcher.off(eventDispatchers.SHOW_AMOUNT_ON_MULTIPLER_REEL, this.showMultiplerPriceOnReel, this);
  }

  private initializeElements(): void {
    this.triggeredSymbol = (ingenuity.parserModel as GameParserModel).getBonusTriggeringOffset();
  }

  /**
   * function to handle prize update for big prize
   */
  private updatePrizeForBigPrize(): void {
    if (this.index < this.triggeredSymbol.length) {
      if (this.triggeredSymbol[this.index].symbolType === gameConstants.SKULL_BIG_PRIZE) {
        this.tweenArray = [];
        this.trailCounter = 0;
        if (this.triggeredSymbol[this.index].reward.length) {
          this.triggerType = gameConstants.SKULL_BIG_PRIZE;
          this.startBigPrizeTrail();
        } else {
          ++this.index;
          this.updatePrizeForBigPrize();
        }
      } else {
        ++this.index;
        this.updatePrizeForBigPrize();
      }
    } else {
      this.onEndPriceUpdate();
    }
  }

  /**
   * function to end update and call next feature
   */
  private onEndPriceUpdate(): void {
    delayedCall(
      "endPriceUpdate",
      gameConstants.ONE_SECOND_DELAY,
      () => {
        this.resetUpdatePrize();
        dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
      },
      this
    );
  }

  /**
   * function to handle prize update for collectAll
   */

  private updatePrizeForCollectAll(): void {
    if (this.index < this.triggeredSymbol.length) {
      if (
        this.triggeredSymbol[this.index].symbolType === gameConstants.SKULL_COLLECT_ALL &&
        this.triggeredSymbol[this.index].reward == "collectAll"
      ) {
        // create trail from all skull on reel to one skull
        this.collectAllSkullPriceUpdated = false;
        this.tweenArray = [];
        this.trailCounter = 0;
        this.triggerType = gameConstants.SKULL_COLLECT_ALL;
        this.collectAllPrizeToSkull();
      } else {
        ++this.index;
        this.updatePrizeForCollectAll();
      }
    } else {
      this.onEndPriceUpdate();
    }
  }

  /**
   * start trail from all skull symbol to current theme symbol
   */
  private collectAllPrizeToSkull(): void {
    let containerObj = this.view.getContainerByID(
      gameConstants.SYMBOL_REEL + this.triggeredSymbol[this.index].offSet[0] + this.triggeredSymbol[this.index].offSet[1]
    );
    this.allInitialSkulls = (ingenuity.parserModel as GameParserModel).getBonusCoinsInitialData();
    this.allInitialSkulls.forEach((element: any, index: number) => {
      if (element.position !== this.triggeredSymbol[this.index].pos) {
        this.triggeredSymbol[this.index].prize = this.triggeredSymbol[this.index].prize + element.prize;
        this.playTrailAnimation(element.offSet[0], element.offSet[1], { x: containerObj.x, y: containerObj.y }, false, element.color);
      }
    });
  }

  /**
   * start trail from all skull symbol to current collect all symbol on reel
   */
  private showCollectAllPriceOnReel(evt: IEvent): void {
    this.collectAllReelData = evt.data;
    this.triggerType = gameConstants.SKULL_COLLECT_ALL;
    this.ifOnReelSymbol = true;
    this.playTrailForCollectAllOnReel(0);
  }

  private playTrailForCollectAllOnReel(rewardIndex: number = 0) {
    if (rewardIndex < this.collectAllReelData.length) {
      this.tweenArray = [];
      this.trailCounter = 0;
      this.collectAllSkullPriceUpdated = false;
      this.onReeloffSet = this.collectAllReelData[rewardIndex].offSet;
      let position = this.collectAllReelData[rewardIndex].position;
      let containerObj = this.view.getContainerByID(gameConstants.SYMBOL_REEL + this.onReeloffSet[0] + this.onReeloffSet[1]);
      this.allInitialSkulls = (ingenuity.parserModel as GameParserModel).getBonusWinCoinData();
      this.allInitialSkulls.forEach((element: any, index: number) => {
        if (element.position !== position) {
          this.playTrailAnimation(
            element.offSet[0],
            element.offSet[1],
            { x: containerObj.x, y: containerObj.y },
            false,
            element.color,
            rewardIndex
          );
        } else {
          this.index = index;
        }
      });
    } else {
      this.resetUpdatePrize();
      dispatcher.fireEvent(eventDispatchers.CHECK_FOR_MULTIPLER_ON_REEL);
    }
  }

  private updateCollectAllPrizeAfterTrail(rewardIndex: number = -1): void {
    if (this.ifOnReelSymbol) {
      this.showCoinWithAmountOnReel(
        this.onReeloffSet[0],
        this.onReeloffSet[1],
        this.allInitialSkulls[this.index].color,
        this.allInitialSkulls[this.index].prize
      );
      delayedCall("playNextCollectAllOnReel", 220, () => {
        killDelayedCall("playNextCollectAllOnReel");
        this.playTrailForCollectAllOnReel(++rewardIndex);
      });
    } else {
      this.showCoinWithAmountOnReel(
        this.triggeredSymbol[this.index].offSet[0],
        this.triggeredSymbol[this.index].offSet[1],
        this.triggeredSymbol[this.index].color,
        this.triggeredSymbol[this.index].prize
      );
      delayedCall(
        "checkMoreUpdatePrize",
        500,
        () => {
          killDelayedCall("checkMoreUpdatePrize");
          this.updateBigPriceInitialData();
          this.index++;
          this.updatePrizeForCollectAll();
        },
        this
      );
    }
  }
  /**
   * method to check if multipler is triggered or not
   */
  private updatePrizeForMutiplier() {
    if (this.index < this.triggeredSymbol.length) {
      if (this.triggeredSymbol[this.index].symbolType == gameConstants.SKULL_MULTIPLIER) {
        this.tweenArray = [];
        this.trailCounter = 0;
        this.triggerType = gameConstants.SKULL_MULTIPLIER;
        this.startMultiplierTrail(this.triggeredSymbol[this.index].offSet[0], this.triggeredSymbol[this.index].offSet[1]);
      } else {
        ++this.index;
        this.updatePrizeForMutiplier();
      }
    } else {
      this.onEndPriceUpdate();
    }
  }

  /**
   * start big prize prize update for on reel symbol
   */
  private showMultiplerPriceOnReel(evt: IEvent): void {
    this.multiplerReelData = evt.data;
    this.tweenArray = [];
    this.trailCounter = 0;
    this.multiplierReelIndex = 0;
    this.triggerType = gameConstants.SKULL_MULTIPLIER;
    this.ifOnReelSymbol = true;
    this.allInitialSkulls = (ingenuity.parserModel as GameParserModel).getBonusWinCoinData();
    this.playTrailAnimationMultiplierOnReel();
  }

  private playTrailAnimationMultiplierOnReel(): void {
    if (this.multiplierReelIndex < this.multiplerReelData.length) {
      this.startMultiplierTrail(this.multiplerReelData[this.multiplierReelIndex].offSet[0], this.multiplerReelData[this.multiplierReelIndex].offSet[1]);
    } else {
      this.resetUpdatePrize();
      this.allInitialSkulls = (ingenuity.parserModel as GameParserModel).getUpdatedBonusCoinsData();
      let newCoins = (ingenuity.parserModel as GameParserModel).getBonusCoinsData();
      newCoins.forEach((element: any) => {
        this.allInitialSkulls.push(element);
      });
      (ingenuity.parserModel as GameParserModel).setUpdatedBonusCoinsData(this.allInitialSkulls);
    }
  }

  /**
   * reset all the properties after update price
   */

  private resetUpdatePrize(): void {
    this.index = 0;
    this.trailCounter = 0;
    this.allInitialSkulls = [];
    this.triggerType = undefined;
    this.ifOnReelSymbol = false;
    this.bigPrizeReelData = [];
    this.collectAllReelData = [];
    this.bigPrizeReelIndex = 0;
    this.multiplierReelIndex = 0;
    this.collectAllSkullPriceUpdated = false;
  }

  /**
   * start big prize prize update for on reel symbol
   */
  private showBigPrizePriceOnReel(evt: IEvent): void {
    this.bigPrizeReelData = evt.data;
    this.tweenArray = [];
    this.trailCounter = 0;
    this.triggerType = gameConstants.SKULL_BIG_PRIZE;
    this.ifOnReelSymbol = true;
    this.allInitialSkulls = (ingenuity.parserModel as GameParserModel).getBonusWinCoinData();
    this.playTrailAnimationBigPrizeOnReel();
  }

  /**
   * method to start upadte price for each big price on reel
   */
  private playTrailAnimationBigPrizeOnReel(): void {
    if (this.bigPrizeReelIndex < this.bigPrizeReelData.length) {
      let position = this.bigPrizeReelData[this.bigPrizeReelIndex].position;
      this.index = this.allInitialSkulls.findIndex((element) => element.position === position);
      this.calculateReward();
      this.startUpdatePriceBigPrizeReel(0);
    } else {
      this.resetUpdatePrize();
      dispatcher.fireEvent(eventDispatchers.CHECK_FOR_COLLECT_ALL_ON_REEL);
    }
  }

  /**
   * calculate reward on symbol before applying big prize as we are receiving final price from response and we need to show price one by one
   */
  private calculateReward(): void {
    this.allInitialSkulls[this.index].reward.forEach((element: any) => {
      if (typeof element !== "string") {
        this.allInitialSkulls[this.index].prize = this.allInitialSkulls[this.index].prize - element;
      } else {
        let jpAmount = this.getJpAmount(element);
        this.allInitialSkulls[this.index].prize = this.allInitialSkulls[this.index].prize - jpAmount;
      }
    });
  }

  /**
   * start price update for each reward on one reel skull
   * @param rewardIndex index for reward
   */
  private startUpdatePriceBigPrizeReel(rewardIndex: number = 0) {
    if (rewardIndex < this.allInitialSkulls[this.index].reward.length) {
      this.onReeloffSet = this.bigPrizeReelData[this.bigPrizeReelIndex].offSet;
      const endPosition: Container = this.view.getContainerByID(gameConstants.SYMBOL_REEL + this.onReeloffSet[0] + this.onReeloffSet[1]);
      let effects = endPosition.getChildByName("symbolEffects" + this.onReeloffSet[0] + this.onReeloffSet[1]) as SpineBase;
      effects.visible = true;
      effects.playAnim("skull_round_effect_blue");
      effects.onComplete.addOnce(() => {
        effects.visible = false;
        this.playTrailAnimationFromLeftSymbols(
          this.onReeloffSet[0],
          this.onReeloffSet[1],
          { x: endPosition.x, y: endPosition.y },
          rewardIndex,
          gameConstants.BIG_PRIZE
        );
      });
    } else {
      ++this.bigPrizeReelIndex;
      this.playTrailAnimationBigPrizeOnReel();
    }
  }

  /**
   * method to play trail from left character to big prize symbol on reel
   * @param data
   */

  private startBigPrizeTrail(rewardIndex: number = 0): void {
    if (rewardIndex < this.triggeredSymbol[this.index].reward.length) {
      const endPosition: Container = this.view.getContainerByID(
        gameConstants.SYMBOL_REEL + this.triggeredSymbol[this.index].offSet[0] + this.triggeredSymbol[this.index].offSet[1]
      );
      let effects = endPosition.getChildByName(
        "symbolEffects" + this.triggeredSymbol[this.index].offSet[0] + this.triggeredSymbol[this.index].offSet[1]
      ) as SpineBase;
      effects.visible = true;
      effects.playAnim("skull_round_effect_blue", false);
      effects.onComplete.addOnce(() => {
        effects.visible = false;
        this.playTrailAnimationFromLeftSymbols(
          this.triggeredSymbol[this.index].offSet[0],
          this.triggeredSymbol[this.index].offSet[1],
          { x: endPosition.x, y: endPosition.y },
          rewardIndex,
          gameConstants.BIG_PRIZE
        );
      });
    } else {
      this.updateBigPriceInitialData();
      this.index++;
      this.updatePrizeForBigPrize();
    }
  }

  /**
   * funtion to update price of big prize skull on reel
   * @param rewardIndex
   */
  private updateBigPrizeAfterTrail(rewardIndex: number): void {
    let reward;
    (ingenuity.soundManager as any).playSound(SoundConstantGame.BLUE_TRAIL_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);

    if (this.ifOnReelSymbol) {
      if (this.allInitialSkulls[this.index].reward[rewardIndex]) {
        this.updateBigPrizeReward(this.allInitialSkulls[this.index].reward[rewardIndex]);
      }
      if (typeof this.allInitialSkulls[this.index].reward[rewardIndex] === "string") {
        reward = this.allInitialSkulls[this.index].reward[rewardIndex];
      }
      this.showCoinWithAmountOnReel(
        this.onReeloffSet[0],
        this.onReeloffSet[1],
        this.allInitialSkulls[this.index].color,
        this.allInitialSkulls[this.index].prize,
        reward
      );
      delayedCall("nextTrailAnimationBigPrizeOnReel", 200, () => {
        killDelayedCall("nextTrailAnimationBigPrizeOnReel");
        this.startUpdatePriceBigPrizeReel(++rewardIndex);
      });
    } else {
      this.allInitialSkulls = (ingenuity.parserModel as GameParserModel).getBonusCoinsInitialData();
      if (this.triggeredSymbol[this.index].reward[rewardIndex]) {
        this.updateBigPrizeReward(this.triggeredSymbol[this.index].reward[rewardIndex]);
      }
      if (typeof this.triggeredSymbol[this.index].reward[rewardIndex] === "string") {
        reward = this.triggeredSymbol[this.index].reward[rewardIndex];
      }
      this.showCoinWithAmountOnReel(
        this.triggeredSymbol[this.index].offSet[0],
        this.triggeredSymbol[this.index].offSet[1],
        this.triggeredSymbol[this.index].color,
        this.triggeredSymbol[this.index].prize,
        reward
      );
      this.startBigPrizeTrail(++rewardIndex);
    }
  }

  /**
   * update price after applying big prize for next symbol
   */
  private updateBigPriceInitialData(): void {
    this.allInitialSkulls.forEach((element) => {
      if (element.position === this.triggeredSymbol[this.index].pos) {
        element.prize = this.triggeredSymbol[this.index].prize;
      }
    });
  }

  /**
   * get jackpot prize
   * @param jpType
   * @returns
   */
  private getJpAmount(jpType: string): number {
    let jpAmount: number;
    if (jpType == "mini") {
      jpAmount = (ingenuity.parserModel as GameParserModel).getJackpotData().mini;
    } else if (jpType == "major") {
      jpAmount = (ingenuity.parserModel as GameParserModel).getJackpotData().major;
    } else if (jpType == "minor") {
      jpAmount = (ingenuity.parserModel as GameParserModel).getJackpotData().minor;
    }
    return jpAmount;
  }

  private updateBigPrizeReward(reward: number | string): void {
    if (typeof reward == "string") {
      let jpAmount = this.getJpAmount(reward);
      if (this.ifOnReelSymbol) {
        this.allInitialSkulls[this.index].prize = this.allInitialSkulls[this.index].prize + jpAmount;
      } else {
        this.triggeredSymbol[this.index].prize = this.triggeredSymbol[this.index].prize + jpAmount;
      }
    } else {
      if (this.ifOnReelSymbol) {
        this.allInitialSkulls[this.index].prize = this.allInitialSkulls[this.index].prize + reward;
      } else {
        this.triggeredSymbol[this.index].prize = this.triggeredSymbol[this.index].prize + reward;
      }
    }
  }

  /**
   * add amount on reel
   * @param reel
   * @param pos
   * @param color
   * @param amount
   * @param isLanding
   * @param reward
   */
  private showCoinWithAmountOnReel(reel: number, pos: number, color: string, amount: string, reward: number | string = undefined): void {
    const containerObj = this.view.getContainerByID(gameConstants.SYMBOL_REEL + reel + pos);
    let amountInCredit;
    if (reward && typeof reward !== "string") {
      amountInCredit = (
        Number(amount) *
        Number(reward) *
        (ingenuity.parserModel as GameParserModel).getCurrentTotalBet() *
        gameConstants.SHOW_AMOUNT_SKULL_MULTIPLER
      )
        .toFixed(2)
        .toString();
    } else {
      amountInCredit = (
        Number(amount) *
        (ingenuity.parserModel as GameParserModel).getCurrentTotalBet() *
        gameConstants.SHOW_AMOUNT_SKULL_MULTIPLER
      )
        .toFixed(2)
        .toString();
    }
    let symbol = containerObj.getChildByName(`${color}_Symbols`) as SpineBase;
    let child = containerObj.getChildByName(color) as Meter;
    //let spine = containerObj.getChildByName('symbolEffects'+reel+pos) as SpineBase
    //if amount already showing then update
    if (child) {
      //this.playBlastAnim(spine,color);
      symbol.playAnim("bonus_collect");
      symbol.onComplete.addOnce(() => {
        symbol.playAnim("idle", true);
      });
      child.setValue(Number(amountInCredit));
    } else {
      //if amount not showing then add meter
      let meterBitmapClone: Meter = this.view.getMeterBitmapJsonAndClone(color);
      meterBitmapClone.setValue(Number(amountInCredit));
      meterBitmapClone.visible = true;
      symbol.playAnim("bonuswin");
      symbol.onComplete.addOnce(() => {
        symbol.playAnim("idle", true);
      });
      containerObj.addChild(meterBitmapClone);
    }
    //if reward is awarded (big prize theme)
    if (reward) {
      if (typeof reward == "string") {
        //if jackpot is awarded
        if (reward !== gameConstants.COLLECT_ALL) {
          this.checkIfAlreadyHasJackpotReward(containerObj);
          let colorName = this.getColorTheme(color);
          let rewardImg = this.view.getSpineJsonAndClone("symbol_skull_text");
          rewardImg.name = reward + "_reward";
          containerObj.addChild(rewardImg);
          rewardImg.visible = true;
          rewardImg.playAnim(`${colorName.toLowerCase()}_${reward}`);
        }
      } else if (!this.ifOnReelSymbol) {
        //if multiplier is awareded
        this.triggeredSymbol[this.index].prize = Number(this.triggeredSymbol[this.index].prize) * reward;
        amountInCredit = (
          this.triggeredSymbol[this.index].prize *
          gameConstants.SHOW_AMOUNT_SKULL_MULTIPLER *
          (ingenuity.parserModel as GameParserModel).getCurrentTotalBet()
        )
          .toFixed(2)
          .toString();
      }
    }
  }

  /**
   * remove old jp image from symbol if got new jackpot
   * @param containerObj
   */
  private checkIfAlreadyHasJackpotReward(containerObj: Container): void {
    let child = containerObj.children[4];
    if (child) {
      containerObj.removeChildAt(4);
    }
  }

  private getColorTheme(color: string): string {
    let colorName: string;
    switch (color) {
      case "multiplier":
        colorName = "Red";
        break;
      case "bigPrize":
        colorName = "Blue";
        break;
      case "collectAll":
        colorName = "Green";
        break;
      default:
        colorName = "Red";
        break;
    }
    return colorName;
  }

  /**
   * method to start trail from multiplier symbol to left side animation
   */
  private startMultiplierTrail(reel: number, pos: number): void {
    let enPos = this.calculateMidPositionForThemeCharacter();
    (ingenuity.soundManager as any).playSound(SoundConstantGame.RED_TRAIL_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    this.playTrailAnimation(reel, pos, { x: enPos.x, y: enPos.y }, true, gameConstants.MULTIPLIER);
  }

  /**
   * function to calculate mid posotion of triggered theme character
   * @returns x,y position in an object
   */
  private calculateMidPositionForThemeCharacter(): { x: number; y: number } {
    const endPosX = this.view.getContainerByID("baseGameLeftBonusPanelContainer").x + this.view.getSpineById(`type_${this.triggerType}`).x;
    const endPosY = this.view.getContainerByID("baseGameLeftBonusPanelContainer").y + this.view.getSpineById(`type_${this.triggerType}`).y;
    let obj = { x: endPosX, y: endPosY };
    return obj;
  }

  private flowAfterTrailMultiplier(): void {
    //show value on multipler skull
    dispatcher.fireEvent(eventDispatchers.PLAY_HIT_ANIM_RESPIN, { charId: gameConstants.SKULL_MULTIPLIER });
    let multipler: number;
    if (this.ifOnReelSymbol) {
      let reward;
      multipler = this.multiplerReelData[this.multiplierReelIndex].multiplier;
      if(typeof this.multiplerReelData[this.multiplierReelIndex].reward == 'string'){
       reward = this.multiplerReelData[this.multiplierReelIndex].reward;
      }
      this.showCoinWithAmountOnReel(
        this.multiplerReelData[this.multiplierReelIndex].offSet[0],
        this.multiplerReelData[this.multiplierReelIndex].offSet[1],
        "multiplier",
        this.multiplerReelData[this.multiplierReelIndex].prize,
        reward
      );
    } else {
      multipler = this.triggeredSymbol[this.index].multiplier;
      this.showCoinWithAmountOnReel(
        this.triggeredSymbol[this.index].offSet[0],
        this.triggeredSymbol[this.index].offSet[1],
        this.triggeredSymbol[this.index].color,
        this.triggeredSymbol[this.index].prize
      );
    }
    this.playMultiplierAnimLeft(multipler);
  }

  /**
   * function to play multiplier anim on left multiplier character
   */
  private playMultiplierAnimLeft(multiplier: number): void {
    //show multiplier value on theme character
    this.view.getSpineById(`type_151`).playAnim("stage_3_idle_without_multiplier_text", true);
    let baseContainer = this.view.getContainerByID("baseGameLeftBonusPanelContainer");
    let child = baseContainer.getChildByName("multiplierValue");
    child.pivot.set(220, 70);
    child.x = 0;
    child.y = this.view.getSpineById(`type_${this.triggerType}`).y + 52;
    child.visible = true;
    dispatcher.fireEvent(eventDispatchers.PLAY_MULTIPLIER_LOOP_ANIM);
    (ingenuity.soundManager as any).playSound(SoundConstantGame.MULTIPLER_LOOP_SOUND, 1, true, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    this.playLoopAnimation(1, child, multiplier);
  }

  /**
   * funtion for multiplier loop animation
   * @param i index
   * @param child multiplier meter
   * @returns
   */
  private playLoopAnimation(i: number, child: any, multiplier: number): void {
    if (i >= 3) return;
    child.setText(`X${this.multiplierValues[0]}`);
    let wildSymAlphaTween = ingenuity.currentGame.add.tween(child.scale).to({ x: 0.1, y: 0.1 }, 150, undefined, true, 0, 0, true);
    wildSymAlphaTween.onComplete.addOnce(() => {
      if (multiplier == this.multiplierValues[0] && i == 2) {
        this.updatePrizeMul();
      } else {
        child.setText(`X${this.multiplierValues[1]}`);
        wildSymAlphaTween = ingenuity.currentGame.add.tween(child.scale).to({ x: 0.1, y: 0.1 }, 150, undefined, true, 0, 0, true);
        wildSymAlphaTween.onComplete.addOnce(() => {
          if (multiplier == this.multiplierValues[1] && i == 2) {
            this.updatePrizeMul();
          } else {
            child.setText(`X${this.multiplierValues[2]}`);
            wildSymAlphaTween = ingenuity.currentGame.add.tween(child.scale).to({ x: 0.1, y: 0.1 }, 150, undefined, true, 0, 0, true);
            wildSymAlphaTween.onComplete.addOnce(() => {
              if (multiplier == this.multiplierValues[2] && i == 2) {
                this.updatePrizeMul();
              } else {
                this.playLoopAnimation(2, child, multiplier);
              }
            });
          }
        });
      }
    });
  }
  //update each skull's price value
  private updatePrizeMul() {
    (ingenuity.soundManager as any).stop(SoundConstantGame.MULTIPLER_LOOP_SOUND, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    dispatcher.fireEvent(eventDispatchers.STOP_MULTIPLIER_LOOP_ANIM);
    if (!this.ifOnReelSymbol) {
      this.allInitialSkulls = (ingenuity.parserModel as GameParserModel).getBonusCoinsInitialData();
    }
    delayedCall(
      "updatePrizeOnAllSymbol",
      200,
      () => {
        killDelayedCall("updatePrizeOnAllSymbol");
        this.updatePrizeOnAllSymbol(0);
      },
      this
    );
  }

  /**
   *  @param skullCount offset of skull symbol for prize update
   */
  private updatePrizeOnAllSymbol(skullCount: number = 0) {
    if (skullCount < this.allInitialSkulls.length) {
      if (this.allInitialSkulls[skullCount].color === gameConstants.MULTIPLIER) {
        if (this.ifOnReelSymbol) {
          const isNewCoin = this.ifNewCoin(this.allInitialSkulls[skullCount].position);
          const isAfterMultiplier = this.allInitialSkulls[skullCount].position > this.multiplerReelData[this.multiplierReelIndex].position;
          if (isNewCoin && isAfterMultiplier) {
            this.updatePrizeOnAllSymbol(++skullCount);
          } else {
            this.playTrailToUpdatePrize(skullCount);
          }
        } else {
          if (this.allInitialSkulls[skullCount].position > this.triggeredSymbol[this.index].pos) {
            this.allInitialSkulls[skullCount].prize = Number(
              this.allInitialSkulls[skullCount].prize * this.triggeredSymbol[this.index].multiplier
            );
            this.updatePrizeOnAllSymbol(++skullCount);
          } else {
            this.playTrailToUpdatePrize(skullCount);
          }
        }
      } else {
        this.playTrailToUpdatePrize(skullCount);
      }
    } else {
      this.updateTriggeredSymbolPrizeMultipler();
      delayedCall("nextMultiplerTrail", 500, () => {
        killDelayedCall("nextMultiplerTrail");
        if (this.ifOnReelSymbol) {
          this.multiplierReelIndex++;
          this.playTrailAnimationMultiplierOnReel();
        } else {
          this.index++;
          this.updatePrizeForMutiplier();
        }
      });
    }
  }

  private ifNewCoin(position: number): boolean {
    let newCoins = (ingenuity.parserModel as GameParserModel).getBonusCoinsData();
    return newCoins.some((item) => item.position === position);
  }

  private updateTriggeredSymbolPrizeMultipler(): void {
    this.triggeredSymbol.forEach((element: any, index: number) => {
      if (index > this.index) {
        this.triggeredSymbol[index].prize = Number(this.triggeredSymbol[index].prize * this.triggeredSymbol[this.index].multiplier);
      }
    });
  }

  /**
   * to start trail from left character to skull symbol
   * @param skullCount offset of skull symbol for prize update
   */

  private playTrailToUpdatePrize(skullCount: number) {
    let containerObj = this.view.getContainerByID(
      gameConstants.SYMBOL_REEL + this.allInitialSkulls[skullCount].offSet[0] + this.allInitialSkulls[skullCount].offSet[1]
    );
    this.playTrailAnimationFromLeftSymbols(
      this.allInitialSkulls[skullCount].offSet[0],
      this.allInitialSkulls[skullCount].offSet[1],
      { x: containerObj.x, y: containerObj.y },
      skullCount,
      gameConstants.MULTIPLIER
    );
    delayedCall(
      "nextPrizeUpdate",
      800,
      () => {
        killDelayedCall("nextPrizeUpdate");
        this.updatePrizeOnAllSymbol(++skullCount);
      },
      this
    );
  }

  private updateMultiplierPrizeAfterTrail(col: number, row: number, skullCount: number): void {
    if (this.ifOnReelSymbol) {
      this.showCoinWithAmountOnReel(
        this.allInitialSkulls[skullCount].offSet[0],
        this.allInitialSkulls[skullCount].offSet[1],
        this.allInitialSkulls[skullCount].color,
        this.allInitialSkulls[skullCount].prize,
        this.multiplerReelData[this.multiplierReelIndex].multiplier
      );
    } else {
      this.showCoinWithAmountOnReel(
        this.allInitialSkulls[skullCount].offSet[0],
        this.allInitialSkulls[skullCount].offSet[1],
        this.allInitialSkulls[skullCount].color,
        this.allInitialSkulls[skullCount].prize,
        this.triggeredSymbol[this.index].multiplier
      );
    }
    delayedCall("saveUpdatedAmtMultipler", SlotConstantsBehavior.DURATION_200, () => {
      killDelayedCall("saveUpdatedAmtMultipler");
      if (this.ifOnReelSymbol) {
        this.allInitialSkulls[skullCount].prize = Number(
          this.allInitialSkulls[skullCount].prize * this.multiplerReelData[this.multiplierReelIndex].multiplier
        );
      } else {
        this.allInitialSkulls[skullCount].prize = Number(
          this.allInitialSkulls[skullCount].prize * this.triggeredSymbol[this.index].multiplier
        );
      }
    });
  }

  /**
   * This method is use to play bonus trail animation from reel to pot
   */
  private playTrailAnimationFromLeftSymbols(
    col: number,
    row: number,
    endPosition: { x: number; y: number },
    skullCount: number,
    color: string
  ): void {
    let themeColor = this.getTrailColor(color);
    this.particleConfig.color = themeColor;
    //start position should be in the middle of themed animation
    let startPosition = this.calculateMidPositionForThemeCharacter();
    //Use to create trail image
    let smokeSprite: any = this.createTrailImageOnLeftAnimation(col, row);
    //Use to create trail emitter
    this.createTrailEmitter(smokeSprite, color);
    //Use to play trail animation on each bonus landed
    this.tostartTrail(col, row, smokeSprite, startPosition, endPosition, false, skullCount);
    this.trailCounter += 1;
  }

  /**
   * This method is use to play bonus trail animation from reel to pot
   */
  private playTrailAnimation(
    col: number,
    row: number,
    endPosition: { x: number; y: number },
    ifMultiplier: boolean,
    color: string = "",
    rewardIndex: number = -1
  ): void {
    let startPosition = { x: this.view.json.smokeSpriteXY[col][row][0], y: this.view.json.smokeSpriteXY[col][row][1] };
    //Use to create trail image
    let smokeSprite: any = this.createTrailImageOnSkull(col, row);
    //Use to create trail emitter
    if (ifMultiplier) {
      this.createTrailEmitterMultipler(smokeSprite);
    } else {
      this.createTrailEmitter(smokeSprite, color);
    }
    //Use to play trail animation on each bonus landed
    this.tostartTrail(col, row, smokeSprite, startPosition, endPosition, ifMultiplier, rewardIndex);
    this.trailCounter += 1;
  }

  /**
   * This method is use to create trail image on skull to left character
   */
  private createTrailImageOnSkull(colNum: number, rowNum: number): BitmapImage {
    let smokeSprite: BitmapImage = new BitmapImage(ingenuity.currentGame, 0, 0, this.view.json.smokeSprite.id);
    smokeSprite.x = this.view.json.smokeSpriteXY[colNum][rowNum][0];
    smokeSprite.y = this.view.json.smokeSpriteXY[colNum][rowNum][1];
    this.particleData.id = this.view.json.smokeSprite.id + "_skull_" + colNum + rowNum;
    this.particleDataRed.id = this.view.json.smokeSprite.id + "_skull_" + colNum + rowNum;
    smokeSprite.name = this.view.json.smokeSprite.name + "_skull_" + colNum + rowNum;
    smokeSprite.alpha = this.view.json.smokeSprite.alpha;
    smokeSprite.scale.set(this.view.json.smokeSprite.scale);
    smokeSprite.anchor.set(this.view.json.smokeSprite.anchorX, this.view.json.smokeSprite.anchorY);
    let smoke: Bitmap = this.view.getImageById("blueParticle");
    smoke.parent.addChild(smokeSprite);
    return smokeSprite;
  }

  /**
   * This method is use to create trail image on left side theme animation
   */
  private createTrailImageOnLeftAnimation(colNum: number, rowNum: number): BitmapImage {
    let smokeSprite: BitmapImage = new BitmapImage(ingenuity.currentGame, 0, 0, this.view.json.smokeSprite.id);
    smokeSprite.visible = false;
    // x, y position of triggered theme
    let startPosition = this.calculateMidPositionForThemeCharacter();
    smokeSprite.x = startPosition.x;
    smokeSprite.y = startPosition.y;
    this.particleData.id = this.view.json.smokeSprite.id + colNum + rowNum;
    smokeSprite.name = this.view.json.smokeSprite.name + colNum + rowNum;
    smokeSprite.alpha = this.view.json.smokeSprite.alpha;
    smokeSprite.scale.set(this.view.json.smokeSprite.scale);
    smokeSprite.anchor.set(this.view.json.smokeSprite.anchorX, this.view.json.smokeSprite.anchorY);
    delayedCall("showParticle", 0, () => {
      killDelayedCall("showParticle");
      smokeSprite.visible = true;
    });
    let smoke: Bitmap = this.view.getImageById("blueParticle");
    smoke.parent.addChild(smokeSprite);
    return smokeSprite;
  }

  private getTrailColor(color: string): Object {
    let themeColor;
    switch (color) {
      case gameConstants.MULTIPLIER:
        themeColor = {
          start: "#f50a0a",
          end: "#f50a0a",
        };
        break;
      case gameConstants.BIG_PRIZE:
        themeColor = {
          start: "#0a39f5",
          end: "#0a39f5",
        };
        break;
      case gameConstants.COLLECT_ALL:
        themeColor = {
          start: "#1df500",
          end: "#1df500",
        };
        break;
      default:
        themeColor = {
          start: "#f5ed0a",
          end: "#f5ed0a",
        };
        break;
    }
    return themeColor;
  }
  /**
   * This method create emitter for trail
   */
  private createTrailEmitter(smokeSprite: BitmapImage, color: string): void {
    let themeColor = this.getTrailColor(color);
    this.particleConfig.color = themeColor;
    const particle: Emitter = ingenuity.currentGame.add.emitter(
      this.view.getContainerByID("bonusGameMainContainer"),
      this.particleData,
      this.particleConfig
    ) as Emitter;
    particle.autoUpdate = true;
    particle.emit = true;
    particle.updateOwnerPos(smokeSprite.x, smokeSprite.y);
  }

  private createTrailEmitterMultipler(smokeSprite: BitmapImage): void {
    const particle: Emitter = ingenuity.currentGame.add.emitter(
      this.view.getContainerByID("bonusGameMainContainer"),
      this.particleDataRed,
      this.particleConfigRed
    ) as Emitter;
    particle.autoUpdate = true;
    particle.emit = true;
    particle.updateOwnerPos(smokeSprite.x, smokeSprite.y);
  }

  /**
   * This method is use to start trail
   */
  private tostartTrail(
    colNum: number,
    rowNum: number,
    smokeSprite: BitmapImage,
    startPosition: { x: number; y: number },
    endPosition: { x: number; y: number },
    ifMultiplier: boolean = false,
    skullCount: number
  ): void {
    let counter: number = this.trailCounter;
    let curveVal = 0.7;
    let startPosX = startPosition.x;
    let startPosY = startPosition.y;
    let endPosX = endPosition.x;
    let endPosY = endPosition.y;
    let position = this.bezierCurve(startPosX, startPosY, endPosX, endPosY, curveVal);
    this.tweenArray.push(
      ingenuity.currentGame.add
        .tween(smokeSprite)
        .to({ x: position[0], y: position[1] }, this.view.json.trailTimers[colNum][rowNum], undefined, true)
    );
    this.tweenArray[counter].onComplete.addOnce(() => {
      ingenuity.currentGame.particles.getEmitterById(this.tweenArray[counter].target.name).emit = false;
      let em: Emitter;
      em = ingenuity.currentGame.particles.getEmitterById(this.tweenArray[counter].target.name);
      em && (em.autoUpdate = false);
      em && em.destroy();
      this.tweenArray[counter].stop();
      this.tweenArray[counter].onUpdateCallback = null;
      ingenuity.currentGame.tweens.remove(this.tweenArray[counter]);
      this.tweenArray[counter].target.parent.removeChild(this.tweenArray[counter].target);
      this.flowAfterTrail(ifMultiplier, colNum, rowNum, skullCount);
    }, this);

    this.tweenArray[counter].onUpdateCallback((evt: IObject) => {
      let em: Emitter;
      em = ingenuity.currentGame.particles.getEmitterById(evt.target.name);
      em && em.updateOwnerPos(evt.target.x, evt.target.y);
    });
  }

  /**
   * function to handle flow after trail
   * @param ifMultiplier
   * @param colNum
   * @param rowNum
   * @param skullCount
   */
  private flowAfterTrail(ifMultiplier: boolean, colNum: number, rowNum: number, skullCount: number): void {
    //flow after trails for all theme
    if (ifMultiplier) {
      //trail from skull to left character
      this.flowAfterTrailMultiplier();
    } else {
      switch (this.triggerType) {
        case gameConstants.SKULL_MULTIPLIER:
          this.updateMultiplierPrizeAfterTrail(colNum, rowNum, skullCount);
          break;
        case gameConstants.SKULL_BIG_PRIZE:
          this.updateBigPrizeAfterTrail(skullCount);
          break;
        case gameConstants.SKULL_COLLECT_ALL:
          if (!this.collectAllSkullPriceUpdated) {
            this.collectAllSkullPriceUpdated = true;
            (ingenuity.soundManager as any).playSound(
              SoundConstantGame.GREEN_COLLECT_ALL_SOUND,
              1,
              false,
              SlotConstantsBehavior.SOUND_LIST_POSTLOAD
            );
            this.updateCollectAllPrizeAfterTrail(skullCount);
          }
          break;
      }
    }
  }

  //create a curve path array position
  private bezierCurve(startX: number, startY: number, endX: number, endY: number, curveFactor: number): number[][] {
    // startX: X-coordinate of the starting point of the line
    // startY: Y-coordinate of the starting point of the line
    // endX: X-coordinate of the ending point of the line
    // endY: Y-coordinate of the ending point of the line
    // curveFactor: Factor determining the amount of curvature in the curve

    // Calculate control point coordinates
    const controlX = (startX + endX) / 2 - Math.abs(startX - endX) * curveFactor; // X-coordinate of the control point (midpoint)
    const controlY = (startY + endY) / 2; // Y-coordinate of the control point

    // Arrays to store X and Y coordinates of points along the curve
    let curveX: number[] = []; // Array to store X coordinates
    let curveY: number[] = []; // Array to store Y coordinates

    // Number of points to calculate along the curve
    const numberOfPoints = 50; // You can adjust this value based on the desired smoothness of the curve

    // Loop to calculate coordinates of points along the curve
    for (let i = 0; i <= numberOfPoints; i++) {
      const t = i / numberOfPoints; // Parameterization along the Bézier curve (ranges from 0 to 1)
      const x = Math.pow(1 - t, 2) * startX + 2 * (1 - t) * t * controlX + Math.pow(t, 2) * endX; // X-coordinate of the point on the curve
      const y = Math.pow(1 - t, 2) * startY + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endY; // Y-coordinate of the point on the curve
      curveX.push(x); // Add X-coordinate to the array
      curveY.push(y); // Add Y-coordinate to the array
    }

    // Return arrays of X and Y coordinates of points along the curve
    return [curveX, curveY];
  }
}
